import React from 'react';
import { Wrench, Globe, Mail, ArrowRight, Sparkles } from 'lucide-react';

interface BottomCallToActionProps {
  onSelectTab: (tabId: string) => void;
}

export const BottomCallToAction: React.FC<BottomCallToActionProps> = ({ onSelectTab }) => {
  const handleNav = (tabId: string) => {
    onSelectTab(tabId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="w-full max-w-5xl mx-auto my-12 px-4 print-hide">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-neutral-950 via-[#0e0e12] to-neutral-950 border border-brand-500/30 p-6 sm:p-10 shadow-[0_0_50px_rgba(245,158,11,0.12)] text-center space-y-6">
        {/* Background Subtle Ambient Glow */}
        <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-96 h-96 bg-brand-500/10 rounded-full blur-3xl pointer-events-none" />

        {/* Header Badge & Title */}
        <div className="relative z-10 space-y-2.5 max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 py-1 px-3.5 rounded-full bg-brand-500/15 border border-brand-500/30 text-brand-300 text-xs font-mono font-bold uppercase tracking-wider select-none">
            <Sparkles className="w-3.5 h-3.5 text-brand-400 animate-pulse" />
            <span>Direct Technical &amp; Web Services</span>
          </div>

          <h3 className="text-2xl sm:text-3xl font-display font-black text-white tracking-tight">
            Ready to Get Started?
          </h3>

          <p className="text-xs sm:text-sm text-slate-300 leading-relaxed font-medium">
            Submit a quick diagnostic request for technical repairs or start our guided website onboarding protocol today.
          </p>
        </div>

        {/* 3 Interactive Buttons */}
        <div className="relative z-10 flex flex-wrap items-center justify-center gap-3 sm:gap-4 pt-2">
          {/* Button 1: Request Repair / Estimate */}
          <button
            type="button"
            onClick={() => handleNav("service-quote")}
            className="px-5 py-3 rounded-2xl bg-gradient-to-r from-brand-500 to-amber-500 hover:from-brand-400 hover:to-amber-400 text-slate-950 font-mono font-bold text-xs uppercase tracking-wider transition-all duration-200 shadow-lg hover:shadow-brand-500/25 active:scale-95 cursor-pointer flex items-center gap-2"
          >
            <Wrench className="w-4 h-4 text-slate-950" />
            <span>Request Repair / Estimate</span>
          </button>

          {/* Button 2: Website Onboarding Guide */}
          <button
            type="button"
            onClick={() => handleNav("website-onboarding")}
            className="px-5 py-3 rounded-2xl bg-neutral-900/90 hover:bg-neutral-800 text-brand-300 hover:text-brand-200 border border-brand-500/40 hover:border-brand-500/70 font-mono font-bold text-xs uppercase tracking-wider transition-all duration-200 shadow-md active:scale-95 cursor-pointer flex items-center gap-2"
          >
            <Globe className="w-4 h-4 text-brand-400" />
            <span>Website Onboarding Guide</span>
          </button>

          {/* Button 3: Contact Directly */}
          <button
            type="button"
            onClick={() => handleNav("contact")}
            className="px-5 py-3 rounded-2xl bg-neutral-900/80 hover:bg-neutral-800 text-white border border-neutral-700/80 hover:border-slate-500 font-mono font-bold text-xs uppercase tracking-wider transition-all duration-200 shadow-md active:scale-95 cursor-pointer flex items-center gap-2"
          >
            <Mail className="w-4 h-4 text-slate-300" />
            <span>Contact Directly</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BottomCallToAction;
